import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as settingsApi from "./api";

const KEY = "email-settings";

export function useEmailSettings() {
  return useQuery({ queryKey: [KEY], queryFn: settingsApi.getEmailSettings });
}

export function useUpdateEmailSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: settingsApi.updateEmailSettings,
    onSuccess: (data) => qc.setQueryData([KEY], data),
  });
}

export function useSendTestEmail() {
  return useMutation({ mutationFn: settingsApi.sendTestEmail });
}

const COMPANY_KEY = "company-settings";

export function useCompanySettings() {
  return useQuery({ queryKey: [COMPANY_KEY], queryFn: settingsApi.getCompanySettings });
}

export function useUpdateCompanySettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: settingsApi.updateCompanySettings,
    onSuccess: (data) => qc.setQueryData([COMPANY_KEY], data),
  });
}

export function useUploadCompanyLogo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: settingsApi.uploadCompanyLogo,
    onSuccess: (data) => qc.setQueryData([COMPANY_KEY], data),
  });
}

export function useDeleteCompanyLogo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: settingsApi.deleteCompanyLogo,
    onSuccess: (data) => qc.setQueryData([COMPANY_KEY], data),
  });
}
